import * as c from '../constants/actionTypes';

let initialState =  {
  submission_details: {
    extras: []
  },
  user_details: {},
  tab: 1,
  loading: false,
  paperLoading: false,
  submissions: [],
  mySubmissions: [],
  submissionsPage: 0,
  availableforeditsubmissions: [],
  myCompleteSubmissions: [],
  mySubmissionsPage: 0,
  studentSubmissionsAvail: [],
  studentSubmissionsAvailTotalCount: 0,
  studentSubmissionsComplete: [],
  studentSubmissionsCompleteTotalCount: 0,
  studentSubmissionsPage: 0,
  invoiceSelect: [],
  invoicePaid: [],
  rating_details: {},
  invoices: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case c.GET_STUDENT_SUBMISSIONS_SUCCESS:
      var newState = state;
      console.log(action);
      newState.studentSubmissionsAvail = action.body.data.available;
      newState.studentSubmissionsAvailTotalCount = action.body.data.totalCount;
      return state = Object.assign({}, state, newState);
    case c.GET_STUDSUBMISSIONCOMPLETE_SUCCESS:
      var newState = state;
      newState.studentSubmissionsCompleteTotalCount = action.body.data.totalCount;
      newState.studentSubmissionsComplete = action.body.data.complete_edits;
      return state = Object.assign({}, state, newState);
    case c.GET_DOCUMENT_DETAILS_SUCCESS:
      var newState = state;
      newState.submission_details = action.body.data[0];
      return state = Object.assign({}, state, newState);
    case c.GET_EDITOR_AVAILABLE_TO_EDIT_SUCCESS:
      var newState = state;
      newState.availableforeditsubmissions = action.body.data;
      return state = Object.assign({}, state, newState);
    case c.UPDATE_TAB:
      var newState = state;
      newState.tab = action.index;
      return state = Object.assign({}, state, newState);
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/StudentDashboard.js